export const types = {
    SET_AUTHORIZE: '[AUTH] SET AUTHORIZE',
    SET_ALLOWS: '[AUTH] SET ALLOWS'
}